import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DriverLookup from '../../components/Form/DriverLookup';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import store from 'store2';
import TextInput from "../../reactis/reactis-inputs/TextInput";

const module = 'invoice';

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/' + module + '/' + row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

		this.columnModel = [
			{
				name: 'ev',
				title: 'VS',
				field: 'ev',
				width: 100,
				renderer: rendererLink
			},
			{
				name: 'date1',
				title: 'Datum',
				field: 'date1',
				width: 120,
				renderer: Renderers.Date
			},
			{
				name: 'date2',
				title: 'Splatnost',
				field: 'date2',
				width: 120,
				renderer: (val) => {
					if (!val) {
						return 'UHRAZENO';
					}
					return Renderers.Date(val);
				}
			},
			{
				name: 'date3',
				title: 'Plnění',
				field: 'date3',
				width: 120,
				renderer: Renderers.Date
			},
			{
				name: 'firm',
				title: 'Firma / řidič',
				field: 'firm',
				renderer: (val, row) => {
					if (row.client_type == 2) {
						return row.dTitle;
					}
					else {
						return row.fTitle;
					}

				}
			},
			{
				name: 'price',
				title: 'Cena',
				width: 80,
				renderer: (valuu, row) => {
					return row.price
				}
			},
			{
				name: 'order',
				title: 'Obj.',
				field: 'order',
				width: 80,
			},
			{
				name: 'status',
				title: 'Stav',
				field: 'status',
				width: 100,
				renderer: Renderers.DbInfo.bind(DbInfo.InvoiceStatus)
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width: 80,
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/' + module + '/' + val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i>Upravit
						</a>
					);
				}
			}
		];

		const filterSchema = {
			fulltext: {class: SearchInput},
			created: {class: DateRange},
			firm: {class: TextInput},
			status: {class: Select, options: DbInfo.InvoiceStatus},
			order: {class: TextInput},
			trnumber: {class: TextInput},
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-' + module);
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'ev', 'direction': 'desc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on(module + '.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener(module + '.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm(module, row.ev, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href={'/' + module + '/0'} onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový daňový doklad
		</Button>;
		return (
			<Datagrid
				ref="datagrid"
				id={module}
				api="invoice.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Invoice/List.js